import {
	types, flow, applySnapshot, Instance,
} from 'mobx-state-tree';

import {
	getLocation,
	saveLocation,
} from '@common/api/locations';

const Location = types
	.model('Location', {
		id: types.identifierNumber,
		name: types.optional(types.string, ''),
	})
	.volatile(() => ({
		loading: false,
	}))
	.actions((self) => ({
		fetch: flow(function* () {
			self.loading = true;
			try {
				const result = yield getLocation(self.id);
				applySnapshot(self, result);
			} finally {
				self.loading = false;
			}
		}),
		save: flow(function* (data: any) {
			self.loading = true;
			try {
				const result = yield saveLocation(self.id, data);
				applySnapshot(self, result);
			} finally {
				self.loading = false;
			}
		}),
	}));

export default Location;

export interface ILocationModel extends Instance<typeof Location> {}
